import React from "react"
import {FieldViewProps} from "../../../../render/view";
import DropdownValue from "../../../../generic/dropdown/components/dropdown-value";


export default function FieldCrmAccount_View(props: FieldViewProps) {

    const option = props.field._getOption(props.model[props.field.fieldId])

    switch (props.params?.viewType) {

        case 'name-only':
            return <div className={props.className}>{option.label}</div>

        default:
            return <DropdownValue className={props.className} option={option} field={props.field} />
    }

}